export const serviceTimeout = 90000;
